import React from 'react';
import MSCard from './MSCard';
import PageBase from '../../app/PageBase';

class Dashboard extends React.Component {

  static propTypes = {
  };

  constructor(props) {

    super(props);
    this.state = {
      user: props.user,
    };

  }

  render() {

    const { user } = this.state;
    return (

      <MSCard

        user={user}
      />

    );

  }

}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/tracker/Dashboard.js